
import { Middleware } from "redux";
import RootState from "store/state";
import AnyAction from "store/anyAction";
import AppTypes from "store/app/app.types";
import {postMessageToParent} from 'utils';
import { SmartagentEvent } from "./events.types";
import MessagesTypes from "store/messages/messages.types";

const postEvent = (event: SmartagentEvent) => {
    postMessageToParent('smartagent-chat-event', event)
}

const eventsMiddleware: Middleware<{}, RootState> = store => next => (action: AnyAction) => {
    switch (action.type) {
        case AppTypes.INIT_APP:
            postEvent({
                type: "CONTACT_STARTED",
                data: {
                    contactId: action.payload.contactId
                }
            });
            return next(action);
        case AppTypes.END_CHAT:
            postEvent({
                type: "CONTACT_ENDED",
                data: {
                    contactId: store.getState().app.contactId
                }
            });
            return next(action);
        case MessagesTypes.NEW_MESSAGE:
            const message = [action.payload].flat()[0]

            if (message.contentType === 'application/vnd.amazonaws.connect.event.participant.joined' && message.role === 'AGENT') {
                postEvent({
                    type: "CONNECT_TO_AGENT",
                    data: {
                        contactId: store.getState().app.contactId,
                        
                    }
                })
            }
            return next(action)
        case AppTypes.CHAT_EVENT:
            postEvent({
                type: "TRANSFER_TO_QUEUE",
                data: {
                    contactId: store.getState().app.contactId
                }
            })
            return next(action)
        default:
            return next(action);
    }
}

export default eventsMiddleware;
